import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NDDInjectionService } from '@ndk/ng-core';
import { NDDDialogI18nService, NDDDialogService } from '@ndk/ng-dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomDialogService extends NDDDialogService implements OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        injectionService: NDDInjectionService,
        dialogi18nService: NDDDialogI18nService,
        private router: Router,
    ) {
        super(injectionService, dialogi18nService);

        // Fecha o dialog ao redirecionar a rota para o login (ocorre ao expirar o token durante a abertura de algum dialog).
        this.router.events
            .pipe(
                takeUntil(this.ngUnsubscribe),
                filter((event: any) => event instanceof NavigationEnd && event.urlAfterRedirects?.includes('/login')),
            )
            .subscribe({
                next: (): void => {
                    this.close();
                },
            });
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
